import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import s from './Grayscale.scss';

class Grayscale extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul className="breadcrumb">
              <li>
                <a href="https://fluxtech.co">Home</a>
              </li>
              <li>
                <a href="https://fluxtech.co/portfolio">Portfolio</a>
              </li>
              <li>Grayscale</li>
            </ul>
          }
          header="Grayscale"
          subHeader="See the world through the eyes of a robot"
        />
        <section className={s.game}>
          <Grid>
            <Row>
              <Col md={12}>
                <h4>
                  In Grayscale, If you are missing a leg, take the enemy’s.
                </h4>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/grayscale-conceptart-cityscape-v1.jpg"
                  />
                </div>
              </Col>
              <Col md={12}>
                <h4>Story</h4>
                <p>
                  Once home to the smartest minds across the world, BlackPort
                  was a fully automated city. It is now a crumbling ghost town,
                  void of human life. But it still lives, it still breathes with
                  the decrepit and feral robots that continue to maintain the
                  city as if nothing really changed.
                </p>
                <p>
                  Now, a new sentient robot arrives in BlackPort: the Player.
                  First booting up in the heart of the city, the Player has no
                  knowledge or memory of their own creation. The only way to
                  find answers is to venture out and explore the darkest
                  crevices that were lost to time. This is where Grayscale
                  starts.
                </p>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="appartment interior"
                    src="/images/uncompressed/grayscale-conceptart-apartment-v1.jpg"
                  />
                </div>
              </Col>
              <Col md={12}>
                <h4>Gameplay</h4>
                <p>
                  Grayscale’s gameplay centers around a Single-Player’s freedom
                  to explore, survive, and loot in the environment around them.
                  Grayscale is about the “moments” the Player makes. This is
                  done through their use of detachable limbs. Either found in
                  the world or taken from an enemy, the Player can equip limbs
                  with agility, strength, and health benefits. These change what
                  the Player is proficient in. Agility relates to movement and
                  stealth, strength focuses on control and object movement,
                  while health directly relates to how much a Player can get hit
                  or take damage.
                </p>
                <p>
                  The Player can also alter their inner brain workings. This
                  includes an ID chip, eyes, and walkie. The ID chip grants
                  access to locked portions of the city. Different eyes change
                  the player’s ability to see or not see in a specific way. The
                  walkie can be swapped to allow the Player to hear different
                  frequencies or contact things or people on the other end.
                </p>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="GS CA Eco"
                    src="/images/uncompressed/grayscale-conceptart-underground-v1.jpg"
                  />
                  <p>Concept Art | Underground Downtown</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="GS CA Ending"
                    src="/images/uncompressed/grayscale-conceptart-outskirts[ending]-v1.jpg"
                  />
                  <p>Concept Art | Outskirts (Ending)</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="GS_CA_Rooftops.png"
                    src="/images/uncompressed/grayscale-conceptart-uptown-v1.jpg"
                  />
                  <p>Concept Art | Rooftop View of Uptown</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="First Screenshot"
                    src="/images/uncompressed/grayscale-screenshot-firstroom-v1.jpg"
                  />
                  <p>Screenshot | Starting Room</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="City Alleyway"
                    src="/images/uncompressed/grayscale-screenshot-alleyway-v1.jpg"
                  />
                  <p>Screenshot | Alleyway</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="Grayscale Inventory"
                    src="/images/uncompressed/grayscale-screenshot-hud-v1.jpg"
                  />
                  <p>Screenshot | Robot Hud</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.preview}>
                  <img
                    alt="Enemy Robot"
                    src="/images/uncompressed/grayscale-screenshot-enemyrobot-v1.jpg"
                  />
                  <p>Screenshot | Enemy Robot</p>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.download}>
                  <h2>Download</h2>

                  <embed src="https://itch.io/embed/347710?linkback=true&bg_color=4b4b4b&fg_color=ffffff&link_color=f22b00&border_color=ffffff&wmode=opaque" />
                </div>
              </Col>
              <Col md={12}>
                <div className={s.promo}>
                  <h4>Designed and developed in partnership with</h4>
                  <a href="https://fatalstudios.com/">
                    <img
                      alt="Fatal Studios"
                      src="//static1.squarespace.com/static/5b7740155cfd793fbf822548/t/5bec9d60f950b725c708e4bf/1545863280640/?format=1500w"
                    />
                  </a>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(Grayscale);
